// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var AccountAdditionalInfoItemFormatingType;
(function (AccountAdditionalInfoItemFormatingType) {
    AccountAdditionalInfoItemFormatingType[AccountAdditionalInfoItemFormatingType["None"] = 0] = "None";
    AccountAdditionalInfoItemFormatingType[AccountAdditionalInfoItemFormatingType["AssetBalance"] = 1] = "AssetBalance";
    AccountAdditionalInfoItemFormatingType[AccountAdditionalInfoItemFormatingType["CustomAsset"] = 2] = "CustomAsset";
})(AccountAdditionalInfoItemFormatingType || (AccountAdditionalInfoItemFormatingType = {}));
